<script>
    import HtmlSection from '../../components/pagesbuilder/sections/HtmlSection.vue';
    import PreviewSection from "./PreviewSection";

    export default {
        name: "PreviewHtmlSection",
        mixins: [
            PreviewSection,
            HtmlSection
        ]
    }
</script>
